import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

import { baseBox } from '../../internal/styles/layout';
import type { SxProp } from '../../internal/styles/sx';
import sx from '../../internal/styles/sx';

export const ModalContent = styled('div', { shouldForwardProp })<SxProp>(
  baseBox,
  css({
    p: 'big',
  }),
  sx
);
